import Model, { attr, hasMany } from '@ember-data/model';
import { type ContactPhoneEmailItem } from './contact';
import MailchimpEmailSyncModel from './mailchimp-email-sync';

export default class ContactEditEmailModel extends Model {
  // properties to send
  @attr('string') contactId!: string;
  @attr() editData?: {
    value: string;
    label?: string;
    sync_with_mailchimp?: boolean;
  }[];

  // properties returned
  @attr() savedData?: ContactPhoneEmailItem[];
  @hasMany('mailchimp-email-sync', { async: false, inverse: null })
  mailchimpEmailSyncs!: MailchimpEmailSyncModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'contact-edit-email': ContactEditEmailModel;
  }
}
